export default "__VITE_ASSET__CzUH6BfA__"